const TOKEN_KEY = 'seplag-xbot:upload_session';

interface StoredSession {
  token: string;
  expiresAt: number;
  preferredUsername: string;
}

export function storeAuthSession(
  token: string,
  expiresInSeconds: number,
  preferredUsername: string,
): void {
  const session: StoredSession = {
    token,
    expiresAt: Date.now() + expiresInSeconds * 1000,
    preferredUsername,
  };
  try {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(session));
  } catch {
    /* ignore */
  }
}

export function getAuthToken(): string | null {
  const session = readSession();
  if (!session || session.expiresAt <= Date.now()) return null;
  return session.token;
}

export function getPreferredUsername(): string | null {
  const session = readSession();
  if (!session || session.expiresAt <= Date.now()) return null;
  return session.preferredUsername;
}

export function clearAuthSession(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function hasValidAuthSession(): boolean {
  return getAuthToken() !== null;
}

function readSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
}
